import { gql } from '@apollo/client'
import { DXO_EXECUTION } from '../fragments/DXOExecution'

export const GET_DXO_EXECUTION_FOR_ZONE_PATH = gql`
  query GetDXOExecutionForZonePath($input: DXOExecutionForZonePathInput!) {
    dxoExecutionForZonePath(input: $input) {
      results {
        ...DXOExecution
      }
      count
      hasMore
      isLeafNode
    }
  }
  ${DXO_EXECUTION}
`
